<br>
<app-card-header [header]="header"></app-card-header>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 col-sm-12 w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <div class="row">
                <div class="col-lg col-md text-right" style="align-self: center;">
                    <button mat-flat-button color="primary" class="btnSize" (click)="routeAdd()"
                        matTooltip="Novo Registro" skipLocationChange>
                        <i class="fa fa-plus fa-1x btnIcon"></i>
                        Novo
                    </button>
                    <button mat-flat-button color="primary" (click)="showFilter()" class="btnSize"
                        matTooltip="Filtro Detalhado">
                        <i class="fa fa-filter fa-1x btnIcon"></i>
                        Filtro
                    </button>
                    <button mat-flat-button color="primary" (click)="makeSync()" class="btnSize"
                        matTooltip="Sincronizar">
                        <i class="fa fa-refresh fa-1x btnIcon"></i>
                        Sincronizar
                    </button>
                </div>
            </div>
            <br>

            <div class="table-responsive table-height " *ngIf="areaSelect.includes('Básica')">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">


                    <ng-container matColumnDef="CreatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at"
                            class="InputLabelHeaderColor formatField"> Criado em
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_at | date: 'dd/MM/yyyy
                            HH:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CreatedBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_by"
                            class="InputLabelHeaderColor formatField"> Criado por
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_by}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="safra"
                            class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.safra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Site">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="site"
                            class="InputLabelHeaderColor formatField"> Site Beneficiamento
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.site}} </td>
                    </ng-container>

                    <ng-container matColumnDef="NumeroControle">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="numero_controle"
                            class="InputLabelHeaderColor formatField"> Número Controle</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.numero_controle}} </td>
                    </ng-container>

                    <ng-container matColumnDef="NumeroCampo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="numero_campo"
                            class="InputLabelHeaderColor formatField"> Número de Campo</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.numero_campo}} </td>
                    </ng-container>
                    <ng-container matColumnDef="NumeroPasse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="previa_numero_passada_basica"
                            class="InputLabelHeaderColor formatField"> Número do Passe</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.previa_numero_passada_basica}} </td>
                    </ng-container>


                    <ng-container matColumnDef="Peneira">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="peneira"
                            class="InputLabelHeaderColor formatField">
                            Peneira </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.peneira_basica}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Hibrido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="hibrido"
                            class="InputLabelHeaderColor formatField">
                            Híbrido RNC/Linhagem </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.hibrido}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Usuario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="usuario"
                            class="InputLabelHeaderColor formatField">
                            Usuário </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.usuario}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="is_incomplete"
                            class="InputLabelHeaderColor formatField">
                            Status </th>
                        <td mat-cell *matCellDef="let row" [style.color]="row.is_incomplete ? 'red' : 'green'"
                            class="formatField">
                            {{row.is_incomplete ? 'Incompleto' : 'Completo'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>
                                <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                    matTooltip="Editar Registro" (click)="routeEdit(row.id)" skipLocationChange>
                                    <i class="fa fa-edit fa-1x btnIcon"></i>
                                    Editar
                                </button>

                            <button *ngIf="permissionDelete" mat-flat-button color="warn" class="mr-1 mt-2 btnSize" matTooltip="Excluír Registro"
                                (click)="delete(row.id)" skipLocationChange>
                                <i class="fa fa-delete fa-1x btnIcon"></i>
                                Excluír
                            </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBasic"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBasic;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                  <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>
            </div>
            <div class="table-responsive table-height " *ngIf="!areaSelect.includes('Básica')">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">

                    <ng-container matColumnDef="CreatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at"
                            class="InputLabelHeaderColor formatField"> Criado em
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_at | date: 'dd/MM/yyyy
                            HH:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CreatedBy">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_by"
                            class="InputLabelHeaderColor formatField"> Criado por
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_by}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Safra">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="safra"
                            class="InputLabelHeaderColor formatField"> Safra
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.safra}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Site">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="site"
                            class="InputLabelHeaderColor formatField"> Site Beneficiamento
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.site}} </td>
                    </ng-container>

                    <ng-container matColumnDef="NumeroControle">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="numero_controle"
                            class="InputLabelHeaderColor formatField"> Número Controle</th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.numero_controle}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Peneira">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="peneira"
                            class="InputLabelHeaderColor formatField">
                            Peneira </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.peneira}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Hibrido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="hibrido"
                            class="InputLabelHeaderColor formatField">
                            Híbrido RNC/Linhagem </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            {{row.hibrido}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Origem">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="origem"
                            class="InputLabelHeaderColor formatField"> Origem </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.origem}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Destino">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="destino"
                            class="InputLabelHeaderColor formatField">
                            Destino </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.destino}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Usuario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="usuario"
                            class="InputLabelHeaderColor formatField">
                            Usuário </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.usuario}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="is_incomplete"
                            class="InputLabelHeaderColor formatField">
                            Status </th>
                        <td mat-cell *matCellDef="let row" [style.color]="row.is_incomplete ? 'red' : 'green'"
                            class="formatField">
                            {{row.is_incomplete ? 'Incompleto' : 'Completo'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <div>
                                <button mat-flat-button color="primary" class="mr-1 mt-2 btnSize"
                                    matTooltip="Editar Registro" (click)="routeEdit(row.id)" skipLocationChange>
                                    <i class="fa fa-edit fa-1x btnIcon"></i>
                                    Editar
                                </button>
                                
                            <button *ngIf="permissionDelete" mat-flat-button color="warn" class="mr-1 mt-2 btnSize" matTooltip="Excluír Registro"
                                (click)="delete(row.id)" skipLocationChange>
                                <i class="fa fa-delete fa-1x btnIcon"></i>
                                Excluír
                            </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>
                </table>
                <div class="flipped">
                  <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
                </div>
            </div>
        </mat-card>
    </div>
</div>

<app-filter-detail>
    <app-form-cd001-classificacao-filter (filter)="getFilter($event)"></app-form-cd001-classificacao-filter>
</app-filter-detail>



